/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
export default {
    GetAllGroupsForDropDown,
    SaveGrade,
    GetGradesByGroupID,
    UpdateGrade,
    GetGradeDetailsByGroupID
};
async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function SaveGrade(data) {
    const response = await CommonPost('/api/Grade/SaveGrade', null, data);
    return response;
}

async function GetGradesByGroupID(groupID) {
    const response = await CommonGet('/api/Grade/GetGradeDetails', 'groupID=' + parseInt(groupID));
    return response.data;
}
//edit
async function GetGradeDetailsByGroupID(groupID) {
    const response = await CommonGet('/api/Grade/GetGradeByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function UpdateGrade(data) {
    const response = await CommonPost('/api/Grade/UpdateGrade', null, data);
    return response;
}

